import { throttle } from 'lodash-es';
import { type RefObject, useMemo, useState } from 'react';

import { useApplyCallbackOnScroll } from './useApplyCallbackOnScroll.js';

export const useScrollResponsiveChartBounds = (
  chartRef: RefObject<HTMLElement | null> | undefined,
  hasMagnifiers: boolean,
): (() => DOMRect | undefined) => {
  const getBoundingClientRect = () => () =>
    chartRef?.current?.getBoundingClientRect();

  const [getChartBounds, setGetChartBounds] = useState<
    () => DOMRect | undefined
  >(getBoundingClientRect);

  const throttledUpdate = useMemo(
    () =>
      throttle(
        () => {
          setGetChartBounds(getBoundingClientRect);
        },
        16, // ~60fps
        { leading: true, trailing: true },
      ),
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  useApplyCallbackOnScroll(!hasMagnifiers, throttledUpdate);

  return getChartBounds;
};
